export const calculateStreak = (completedTests: any): { current: number; longest: number } => {
  if (!completedTests) return { current: 0, longest: 0 };
  
  const tests = Object.values(completedTests) as any[];
  if (tests.length === 0) return { current: 0, longest: 0 };
  
  // Sort tests by date
  const sortedTests = tests.sort((a, b) => 
    new Date(a.attempted_at).getTime() - new Date(b.attempted_at).getTime()
  );
  
  let currentStreak = 0;
  let longestStreak = 0;
  let tempStreak = 0;
  
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  // Check if there's a test today or yesterday for current streak
  const recentTest = sortedTests[sortedTests.length - 1];
  const recentTestDate = new Date(recentTest.attempted_at);
  
  if (isSameDay(recentTestDate, today) || isSameDay(recentTestDate, yesterday)) {
    // Calculate current streak backwards from most recent test
    for (let i = sortedTests.length - 1; i >= 0; i--) {
      const testDate = new Date(sortedTests[i].attempted_at);
      const expectedDate = new Date(today);
      expectedDate.setDate(expectedDate.getDate() - currentStreak);
      
      if (isSameDay(testDate, expectedDate) || 
          (currentStreak === 0 && isSameDay(testDate, yesterday))) {
        currentStreak++;
      } else {
        break;
      }
    }
  }
  
  // Calculate longest streak
  const testDates = sortedTests.map(test => new Date(test.attempted_at).toDateString());
  const uniqueDates = [...new Set(testDates)];
  
  for (let i = 0; i < uniqueDates.length; i++) {
    tempStreak = 1;
    
    for (let j = i + 1; j < uniqueDates.length; j++) {
      const currentDate = new Date(uniqueDates[j]);
      const prevDate = new Date(uniqueDates[j - 1]);
      const dayDiff = Math.floor((currentDate.getTime() - prevDate.getTime()) / (1000 * 60 * 60 * 24));
      
      if (dayDiff === 1) {
        tempStreak++;
      } else {
        break;
      }
    }
    
    longestStreak = Math.max(longestStreak, tempStreak);
  }
  
  return { current: currentStreak, longest: longestStreak };
};

const isSameDay = (date1: Date, date2: Date): boolean => {
  return date1.toDateString() === date2.toDateString();
};